import React, { useState } from 'react'
import { compose } from 'recompose'
import Script from 'react-load-script'
import { Modal, Button, Spin } from 'antd'
// import styled from 'styled-components'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
import { Block } from '../styles'
import CardModal from './CardModal'

const OmiseCard = compose(
  injectIntl,
  withRouter,
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
)(({ intl, history, registration, payRegistration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted }) => {
  const publicKey = _get(gatewaySettings, 'publicKey', process.env.REACT_APP_OMISE_PUBLIC_KEY) || process.env.REACT_APP_OMISE_PUBLIC_KEY
  const totalAmount = discounted + itemsDiscounted
  const fee = Math.round(gatewayRate * discounted * 100) / 100
  const finalAmount = totalAmount + fee
  // console.log({ gatewayRate, fee })
  const [paymentLoading, setPaymentLoading] = useState(false)
  const [omiseLoaded, setOmiseLoaded] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)

  const handleCheckout = async ({ token, card }) => {
    try {
      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'omise_card',
            data: {
              omise: {
                ...(token && {
                  bin: token.bin,
                  token: {
                    id: token.id,
                    save_card: token.saveCard
                  }
                }),
                ...(card && {
                  card: {
                    id: card.id
                  }
                })
              }
            }
          }
        }
      })
      const { registrationId, data: { omise: { errorCode, error } } } = _get(data, 'payRegistration.record')
      if (errorCode) {
        Modal.error({
          title: intl.formatMessage({ id: 'charge.failureCode.title' }),
          content: intl.formatMessage({ id: `omise.errors.${errorCode}` })
        })
      } else if (error) {
        Modal.error({
          title: intl.formatMessage({ id: 'charge.failureCode.title' }),
          content: error
        })
      } else {
        if (registrationId) {
          return history.push(`/reg/${registrationId}`)
        }
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          Modal.error({
            title: intl.formatMessage({ id: 'charge.failureCode.title' }),
            content: intl.formatMessage({ id: `api.${error.message}` })
          })
        })
      } else {
        Modal.error({
          title: intl.formatMessage({ id: 'charge.failureCode.title' }),
          content: err.message
        })
      }
    } finally {
      setPaymentLoading(false)
    }
  }

  const handleSubmit = async ({ cardId, newCard, saveCard }) => {
    setPaymentLoading(true)
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(publicKey)
    if (cardId === 'new') {
      const { number, name, expiry, cvc } = newCard
      const [mm = '', yy = ''] = expiry.replace(/\s/g, '').split('/')
      const expirationMonth = mm
      const expirationYear = `20${yy.substr(-2)}`
      const cardData = {
        name: name.trim(),
        number: number.replace(/\s/g, ''),
        expiration_year: expirationYear, // eslint-disable-line camelcase
        expiration_month: expirationMonth, // eslint-disable-line camelcase
        security_code: cvc.replace(/\s/g, '') // eslint-disable-line camelcase
      }
      const token = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Omise.createToken('card', cardData, (statusCode, response) => {
          if (statusCode !== 200) {
            Modal.error({
              title: intl.formatMessage({ id: 'charge.failureCode.title' }),
              content: intl.formatMessage({ id: response.message })
            })
            setPaymentLoading(false)
            return reject(response.message)
          }
          return resolve(response)
        })
      })
      return handleCheckout({ token: { id: token.id, saveCard, bin: cardData.number.slice(0, 6) } })
    }
    return handleCheckout({ card: { id: cardId } })
  }

  return <Block>
    <Script
      url="https://cdn.omise.co/omise.js.gz"
      onLoad={() => setOmiseLoaded(true)}
      onError={() => console.error('error loading omise')}
    />
    {omiseLoaded ? <React.Fragment>
      <div className="title">
        <FormattedMessage id="paymentMethod.omise_card" />
      </div>
      <div>
        {systemFee
          ? <React.Fragment>
            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(discounted - totalSystemFee)
            }} />
            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(totalSystemFee)
            }} />
          </React.Fragment>
          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted)
          }} />
        }
        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
          amount: intl.formatNumber(fee)
        }} />
        {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(itemsDiscounted)
        }} />}
      </div>
      <Button
        icon="credit-card"
        type="primary"
        onClick={() => setModalVisible(true)}
        className="paymentButton"
      >
        <FormattedMessage id="app.payBaht" values={{
          amount: intl.formatNumber(finalAmount)
        }} />
      </Button>
      <CardModal
        amount={finalAmount}
        visible={modalVisible}
        loading={paymentLoading}
        onClose={() => setModalVisible(false)}
        onSubmit={handleSubmit}
      />
    </React.Fragment>
      : <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>}
  </Block>
})

export default OmiseCard



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseCard/OmiseCard.js